import * as React from "react";
import { Field } from "formik";
import { Select } from "components/common";
import { PAGE_SIZES, DEFAULT_SIZE } from "report/Constants";
import ControlLabel from "components/bootstrap/ControlLabel";
import Input from "components/bootstrap/Input";
const PageSizeSelect = ({ disabled }) => /* @__PURE__ */ React.createElement(Field, { name: "layout.pageSize" }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Input, { id: name, error }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Size"), /* @__PURE__ */ React.createElement(
  Select,
  {
    disabled,
    onChange: (newValue) => onChange({ target: { name, value: newValue } }),
    value: value != null ? value : DEFAULT_SIZE,
    inputId: name,
    placeholder: "Pick a page size",
    clearable: false,
    options: PAGE_SIZES
  }
)));
export default PageSizeSelect;
